import { DriverStandings, IDriverStandings } from "@sky-it-livedata/livedata-sports-design-system";

import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { DriversRankingQuery } from "./types";

import transformQuery from "./transformers/query-transformer";
import { useIntcmp } from '../../hooks/useIntcmp';

export const setCustomAttributes = ({
  variables,
}: WidgetContext<DriversRankingQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
    props,
}: WidgetContext<DriversRankingQuery> ): IDriverStandings => {
    return transformQuery(props);
};

const DriversRanking = ({
    props,
    ...rest
}: WidgetContext<IDriverStandings> ) => {
    log({ props, ...rest });
    const intCmpEventHandler = useIntcmp();

    return (
        <div onClick={intCmpEventHandler}>
            <DriverStandings {...props} />
        </div>
    );
}

export default DriversRanking